import { BillingDashboard } from '@/components/billing/billing-dashboard';

export default function BillingPage() {
  return <BillingDashboard />;
}

